export enum CookieConsentCookie {
    NAME = 'cookie_consent_setting'
}

export enum CookieConsentTypeMode {
    GRANTED = 'granted',
    DENIED = 'denied'
}

/* Updating the version will invalidate cookie settings and
require the user to re-accept the cookie settings */
export enum CookieConsentVersion {
    VERSION = 'v2'
}
